import angular from 'angular';
import vcRecaptcha from 'angular-recaptcha';

import messagingService from './../messaging/messaging.module';
import captchaService from '../captcha/captcha.module'
import { ContactAskCallbackComponent } from './contact-ask-callback.component';

const MODULE_NAME = 'contactAskCallback';

export default angular.module(MODULE_NAME, [messagingService, vcRecaptcha, captchaService]).component('contactAskCallback', ContactAskCallbackComponent).name;
